import { UI_ACTIONS } from 'store/v1/ui/ui.constants';

import { myToastService } from 'v5/services/front/ToastService/ToastService.connected.js';
import mapAlertError from 'v1/helpers/alertErrors';
import { resourceDrawerGuard } from 'v5/features/resources/resourceDrawerGuard';
import { values } from 'lodash';

const closeModal = () => {
  return { type: UI_ACTIONS.CLOSE_MODAL };
};

/**
 * @param {string} modalType
 * @param {object} [data]
 * @param {import('v5/core/app-scope/appScope.types').AppScope | null} [appScope]
 *   Browsing scope from the opener's lexical context (ModalHandler portal).
 */
const openModal = (modalType, data, appScope = null) => {
  return { type: UI_ACTIONS.OPEN_MODAL, modalType, data, appScope };
};

/**
 * Shows `selectedContact` in the resource drawer. While the drawer holds
 * unsaved changes of another resource it asks first (`resourceDrawerGuard`),
 * and nothing happens when the user keeps editing.
 */
const openContactSidebar = selectedContact => dispatch => {
  const open = () =>
    dispatch({ type: UI_ACTIONS.OPEN_CONTACT_SIDEBAR, selectedContact });
  const answer = resourceDrawerGuard.request(selectedContact);
  if (answer === true) {
    open();
  } else if (answer !== false) {
    answer.then(allowed => {
      if (allowed) open();
    });
  }
};

const closeContactSidebar = () => {
  return { type: UI_ACTIONS.CLOSE_CONTACT_SIDEBAR };
};

const openProductionSidebar = (selectedProduction, options = {}) => {
  return {
    type: UI_ACTIONS.OPEN_PRODUCTION_SIDEBAR,
    selectedProduction,
    options
  };
};

const closeProductionSidebar = () => {
  return { type: UI_ACTIONS.CLOSE_PRODUCTION_SIDEBAR };
};

/**
 * @param {object} selectedBooking
 * @param {{ initialTab?: string, appScope?: import('v5/core/app-scope/appScope.types').AppScope | null }} [options]
 *   Pass `appScope` from the opener’s browsing context (same idea as
 *   {@link openModal}) so send/template actions keep workspace scope.
 */
const openBookingSidebar = (selectedBooking, options = {}) => {
  return { type: UI_ACTIONS.OPEN_BOOKING_SIDEBAR, selectedBooking, options };
};

const closeBookingSidebar = () => {
  return { type: UI_ACTIONS.CLOSE_BOOKING_SIDEBAR };
};

function normalizeAlertBody(body) {
  if (typeof body === 'string') return mapAlertError(body) || body;
  if (body && body.message) return mapAlertError(body.message) || body.message;
  if (body && body.Message && body.errors) {
    const errs = values(body.errors);
    if (errs && errs.length) return errs[0];
  }
  return 'Sorry something has gone wrong';
}

const displayAlert = (alertType, body, data) => {
  return function () {
    // this is our v1 bridge to v5 toast service
    const message = normalizeAlertBody(body);
    myToastService.open({ type: alertType, message });
  };
};

export {
  closeModal,
  openModal,
  displayAlert,
  openContactSidebar,
  closeContactSidebar,
  openProductionSidebar,
  closeProductionSidebar,
  openBookingSidebar,
  closeBookingSidebar
};
